import React from 'react';

import type * as Dictionaries from '@src/@types/dictionary';
import type { IFromToRange, ITermRange } from '@src/@types/ranges';
import { getAmountRangeToString, getRateRangeString, humanizeTermRange } from '@src/helpers/common';
import { useDictionaries } from '@src/reducers/dictionaries';
import { useCardRates } from '@src/reducers/product';

import { Content, Section, Table, Title } from '../../../ui/Table';

import styles from './styles.module.scss';

const Header = () => (
  <Section inversion>
    <Title className={styles.title}>Сумма</Title>
    <Title className={styles.title}>Срок</Title>
    <Title className={styles.title}>Ставка</Title>
    <Title className={styles.title}>Подтверждение дохода</Title>
  </Section>
);

const Body: React.FC = () => {
  const rates = useCardRates();
  const dictionaries = useDictionaries();

  return rates && rates.length > 0 ? (
    <>
      {rates.flatMap(({ _id: id, periods, amount, currency, comment, solvencyProofs }) => (
        <>
          {periods.map(({ term, rate }, index) => (
            <Section
              // eslint-disable-next-line react/no-array-index-key
              key={`${id}-${index}`}
              inversion
            >
              <Content className={styles.content}>
                {amount ? (
                  getAmountRangeToString({ amountRange: amount as IFromToRange, currency })
                ) : (
                  <div>&mdash;</div>
                )}
              </Content>
              <Content className={styles.content}>{humanizeTermRange(term as ITermRange)}</Content>
              <Content className={styles.content}>{getRateRangeString(rate as IFromToRange)}</Content>
              <Content className={styles.content}>{getProofAbilityToPay(solvencyProofs, dictionaries)}</Content>
            </Section>
          ))}
          {comment && (
            <Section key={`${id}-comment`} inversion>
              <Content className={styles.content} colSpan={5} dangerouslySetInnerHTML={{ __html: comment }} />
            </Section>
          )}
        </>
      ))}
    </>
  ) : null;
};

export const Rates: React.FC = () => (
  <div className={styles.container}>
    <div className={styles.inner}>
      <Table className={styles.table}>
        <tbody>
          <Header />
          <Body />
        </tbody>
      </Table>
    </div>
  </div>
);

function getProofAbilityToPay(
  solvencyProofs: Array<Dictionaries.DictionaryValue<'solvencyProof'>>,
  dictionaries: Dictionaries.IList,
) {
  return (
    dictionaries.solvencyProof.fields
      .filter((f) => solvencyProofs.includes(f.value))
      .map((f) => f.name)
      .join(' / ') || 'не требуется'
  );
}
